import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { useFeatureFlag } from '@/hooks';
import { LoadingState } from './LoadingState';

interface FeatureFlagRouteProps {
  flag: string;
  redirectTo?: string;
  children: ReactNode;
}

export function FeatureFlagRoute({ flag, redirectTo = '/', children }: FeatureFlagRouteProps) {
  const { enabled, isLoading } = useFeatureFlag(flag);

  if (isLoading) {
    return <LoadingState />;
  }

  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}

export type { FeatureFlagRouteProps };
